import React, { useMemo } from 'react';
import { Card, Typography } from 'antd';
import styled from 'styled-components';
import { useAuth } from '../../hooks/useAuth';
import AvailablePlansGrid from './AvailablePlansGrid';
import ActiveMembershipCard from './ActiveMembershipCard';
import useClientProfile from '../../hooks/useClientProfile';

const { Title } = Typography;

const WelcomeCard = styled(Card)`
  margin-bottom: 24px;
  background: linear-gradient(135deg, 
    ${props => props.theme.colors.primary.gradient.start} 0%, 
    ${props => props.theme.colors.primary.gradient.end} 100%);
  color: white;

  .ant-card-body {
    padding: 40px;
  }
`;

const BLOCKING_STATUSES = ['ACTIVE', 'PENDING'];

const Dashboard = () => {
  const { user } = useAuth();
  const { profile } = useClientProfile();
  const currentSubscription = useMemo(() => {
    return profile?.subscription ?? null;
  }, [profile]);


  const hasBlockingSubscription = useMemo(() => {
    if (!currentSubscription) return false;
    return currentSubscription && BLOCKING_STATUSES.includes(currentSubscription.status);
  }, [currentSubscription]);


  return (
    <div style={{ padding: 24 }}>
      <WelcomeCard>
        <Title level={2} style={{ color: 'white', marginBottom: 8 }}>
          ¡Bienvenido, {user?.firstName || user?.email}! 🎉
        </Title>
      </WelcomeCard>

      {!hasBlockingSubscription && (
        <>
          <Title level={4}>Elige tu membresía</Title>
          <AvailablePlansGrid />
        </>
      )}

      {hasBlockingSubscription && (
        <ActiveMembershipCard subscription={currentSubscription} />
      )}
    </div>
  );

};

export default Dashboard;
